export default function formatDateLong(value) {
  if (!value) {
    return null;
  } else {
    return value.format('MMMM D, YYYY');
  }
}
